import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios.js';

export default {
    name: "fieldsReleasingPortal",
    data: function data() {
        return {
            username: '',
            nricFin: '',
            moduleSessionTimeRaw: '',
            roomIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            roomId: 0
        };
    },

    methods: {
        /*
        *  Check / Hold / Release UserName
        * */
        usernameCheck: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
                var returnInfo;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // TODO -> axios connenct router.
                                console.log('\n\n ====== FieldsReleaseingPortal <|-- Username ======\n', key);
                                _context.next = 3;
                                return axios.post('/fieldsOperationPortal/username', { key: key, username: this.username });

                            case 3:
                                returnInfo = _context.sent.data;


                                console.log('\n\n ====== FieldsReleaseingPortal <|-- username returned ======\n', returnInfo, '\n ------------------------');

                                _context.t0 = key;
                                _context.next = _context.t0 === 1001 ? 8 : _context.t0 === 1002 ? 10 : _context.t0 === 1003 ? 12 : 14;
                                break;

                            case 8:
                                alert(returnInfo.username + '\n' + returnInfo.nricFin);return _context.abrupt('break', 14);

                            case 10:
                                alert(returnInfo.info);return _context.abrupt('break', 14);

                            case 12:
                                alert(returnInfo.info);return _context.abrupt('break', 14);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function usernameCheck(_x) {
                return _ref.apply(this, arguments);
            }

            return usernameCheck;
        }(),


        /*
        *   Check / Hold / Release Nric/Fin
        * */
        nricFinCheck: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
                var returnInfo;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // TODO -> axios connenct router.
                                console.log('\n\n ====== FieldsReleaseingPortal <|-- nricFin ======\n', key);

                                _context2.next = 3;
                                return axios.post('/fieldsOperationPortal/nricFin', { key: key, nricFin: this.nricFin });

                            case 3:
                                returnInfo = _context2.sent.data;


                                console.log('\n\n ====== FieldsReleaseingPortal <|-- nricFin returned ======\n', returnInfo, '\n ------------------------');

                                _context2.t0 = key;
                                _context2.next = _context2.t0 === 2001 ? 8 : _context2.t0 === 2002 ? 10 : _context2.t0 === 2003 ? 12 : 14;
                                break;

                            case 8:
                                alert(returnInfo.username + '\n' + returnInfo.nricFin);return _context2.abrupt('break', 14);

                            case 10:
                                alert(returnInfo.info);return _context2.abrupt('break', 14);

                            case 12:
                                alert(returnInfo.info);return _context2.abrupt('break', 14);

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function nricFinCheck(_x2) {
                return _ref2.apply(this, arguments);
            }

            return nricFinCheck;
        }(),


        /*
        *  Check / Hold / Release Module Session Time + Room ID
        * */
        mstimingWithRoomIdCheck: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
                var moduleSessionTimeWroomId, returnInfo;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                // TODO -> axios connenct router.
                                console.log('\n\n ====== FieldsReleaseingPortal <|-- releaseMstimingWithRoomId ======\n', key);
                                moduleSessionTimeWroomId = this.$moment(this.moduleSessionTimeRaw).format('X').toString() + String(this.roomId);
                                _context3.next = 4;
                                return axios.post('/fieldsOperationPortal/moduleSessionTimeWroomId', { key: key,
                                    moduleSessionTimeRaw: this.moduleSessionTimeRaw,
                                    roomId: this.roomId,
                                    moduleSessionTimeWroomId: moduleSessionTimeWroomId });

                            case 4:
                                returnInfo = _context3.sent.data;


                                console.log('\n\n ====== FieldsReleaseingPortal <|-- moduleSessionTimeWroomId returned ======\n', returnInfo, '\n ------------------------');

                                _context3.t0 = key;
                                _context3.next = _context3.t0 === 3001 ? 9 : _context3.t0 === 3002 ? 11 : _context3.t0 === 3003 ? 13 : 15;
                                break;

                            case 9:
                                alert(returnInfo.moduleName + '\n' + returnInfo.sessionTimeRaw + '\n' + returnInfo.trainerName);return _context3.abrupt('break', 15);

                            case 11:
                                alert(returnInfo.info);return _context3.abrupt('break', 15);

                            case 13:
                                alert(returnInfo.info);return _context3.abrupt('break', 15);

                            case 15:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function mstimingWithRoomIdCheck(_x3) {
                return _ref3.apply(this, arguments);
            }

            return mstimingWithRoomIdCheck;
        }()
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/fieldsOperationPortal.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/fieldsOperationPortal.vue
// module chunks = 17